import SupplierAutomationRequests from '../../server/supplierAutomation';
import { addLoading, removeLoading } from './loading';

export const getListSupplierAutomation = (
  limit,
  skip,
  search,
  orderBy = 'DESC',
  field = 'createdAt',
  loading = true,
) => async (dispatch) => {
  if (loading) dispatch(addLoading());
  try {
    const result = await SupplierAutomationRequests.getListSupplierAutomation(limit, skip, search, orderBy, field);
    return result;
  } finally {
    if (loading) dispatch(removeLoading());
  }
};

export const createSupplierAutomation = newSupplierAutomation => async (dispatch) => {
  dispatch(addLoading());
  try {
    await SupplierAutomationRequests.createSupplierAutomation(newSupplierAutomation);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateSupplierAutomation = updSupplierAutomation => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await SupplierAutomationRequests.updateSupplierAutomation(updSupplierAutomation);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};
